import { render } from "./UserProfile.vue?vue&type=template&id=6fbd54eb&bindings={\"userInfo\":\"props\",\"userData\":\"setup\",\"showEditUserInfo\":\"setup\"}"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"
script.render = render

export default script